/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconDrag/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconDrag({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconDrag",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 9,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#323F4B"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconDrag.Svg"
  data-view-path={viewPath}
 viewBox="0 0 9 14"
 style={{'--as-1-Hqg2': alignSelf,'--mt-2-Hqg2': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Hqg2': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Hqg2': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Hqg2': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Hqg2': opacity,'--w-10-Hqg2': typeof width === 'number' ? `${width}px` : width,'--h-11-Hqg2': typeof height === 'number' ? `${height}px` : height,'--f-12-Hqg2': fill,'--a-7-Hqg2': isAnimated ? animation : "none",'--sd-8-Hqg2': isAnimated ? strokeDashoffset : 0,'--sd-9-Hqg2': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconDrag.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M2 4a2 2 0 100-4 2 2 0 000 4zm0 5a2 2 0 100-4 2 2 0 000 4zm2 3a2 2 0 11-4 0 2 2 0 014 0zm3-8a2 2 0 100-4 2 2 0 000 4zm2 3a2 2 0 11-4 0 2 2 0 014 0zm-2 7a2 2 0 100-4 2 2 0 000 4z"
 style={{'--f-12-Hqg2': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}